import { TRACK_IDS } from "../../../analytics/trackIds";
import React from "react";
import { getBroadcastCopy } from "../../../statics/broadcastCopy";
import CinemaIcon from "../../cinema/CinemaIcon";

export default function BackLiveButton({ setIsLiveEdge, isProgram, player }) {
  const copy = getBroadcastCopy();
  const returnToLive = () => {
    // Catch-up streams may have no live tracker; the parent switches the source.
    if (!isProgram && player && !player.isDisposed()) {
      const tracker =
        player.liveTracker ||
        (player.getChild && player.getChild("LiveTracker"));
      if (tracker && typeof tracker.liveCurrentTime === "function") {
        const edge = tracker.liveCurrentTime();
        if (Number.isFinite(edge)) player.currentTime(edge);
      }
    }
    setIsLiveEdge(isProgram ? "2" : "0");
  };
  return (
    <button
      type="button"
      data-track-id={TRACK_IDS.PLAYER_BACK_LIVE}
      className="control-button back-live"
      onClick={returnToLive}
      title={copy.backLive}
    >
      <span className="back-live-dot" aria-hidden="true" />
      <span>{copy.backLive}</span>
      <CinemaIcon name="arrow" />
    </button>
  );
}
